import FinalBookShopsTable from '../components/final_book_shops_table.vue'

export default {
  components: {
    FinalBookShopsTable
  },
  data: () => ({
    message: 'A'
  })
}